import { Checkout } from '@df/checkout/checkout.interfaces';
import { Directive, inject } from '@angular/core';
import { Status } from '@df/core/status';
import { CheckoutFormComponentDef } from '@df/checkout/checkout-form.component.def';
import { IAddressData } from '@df/session/api/address-book/address';
import { DfApiConfigService } from '@df/api/config/df-api-config.service';
@Directive()
export abstract class FastCheckoutFormComponentDef extends CheckoutFormComponentDef {
    private dfApiConfigService = inject(DfApiConfigService);

    private _currentStepName: string;
    /**
     * Currently visible step
     */
    protected override set currentStepName(currentStepName: string) {
        this._currentStepName = currentStepName;
    }
    protected override get currentStepName(): string {
        return this._currentStepName;
    }

    loadStatus = new Status();

    override ngOnInit() {
        this.subscriptions.add(this.loadStatus.subscribe(() => this.detectChanges()));
        this.load();
    }

    protected load(): void {
        Promise.all([this.checkout.load(this.loadStatus), this.dfApiConfigService.loadCountries()])
            .then(results => {
                this.onLoad(results[0]);
            })
            .catch(() => {});
    }

    protected onLoad(result: Checkout.IData): void {
        this.backendData = result;
        super.ngOnInit();
        this.detectChanges();
    }

    get needLogin(): boolean {
        return !this.customer.model.isLoggedIn;
    }
    /**
     * Checks if fast checkout can be used
     * @return {boolean}
     */
    get canCheckout(): boolean {
        // respect custom restriction rule
        if (!this.backendData) {
            return false;
        }
        if (this.backendData['nofastcheckout']) {
            return false;
        }
        if (!this.needLogin) {
            return false;
        }

        if (!this.app.customer.addressBook.hasAddresses) {
            return false;
        }
        return true;
    }

    /**
     * Checks if fast checkout can be shown (including login screen)
     * @return {boolean} [description]
     */
    get canUse(): boolean {
        return this._canUse();
    }

    _canUse(): boolean {
        if (!this.backendData) {
            return false;
        }
        // respect custom restriction rule
        if (this.backendData['nofastcheckout']) {
            return false;
        }
        return this.needLogin || this.canCheckout;
    }

    /**
     * Override billign address getter to server shipping address always
     * @return {IAddressData} [description]
     */
    override get billingAddress(): IAddressData | undefined {
        return this.shippingAddress;
    }

    /**
     * Its alwasy billing to shipping in fast mode
     * @return {boolean}
     */
    override get isBillingToShipping(): boolean {
        return true;
    }
    // overwrite to avoid basket redirection
    override onEmptyBasket() {}

    protected override setInitStep(): void {}
}
